<template lang="html">
  <div>
    <v-layout class="py-3" row wrap>
      <v-flex xs6>
        <h1>{{ data.name }}</h1>
        <img :src="data.img" alt="">
        <v-layout>
          <a style="margin:10px 0px; font-weight: 600;"
            :href="'https://playdate.pro/#/playlist/' + data.id_playlist">{{
              'https://playdate.pro/#/playlist/' + data.id_playlist }}</a>
        </v-layout>
        <VuetifyAudio :file="data.audio" color="success" />
        <img style="max-width: 500px !important; margin-bottom: 20px;" :src="data.preview" alt="">
        <video style="max-width: 500px !important;" controls v-if="data._video" :src="data._video"></video>
      </v-flex>
      <v-flex style="padding-top: 65px;">
        <small>PLAYED</small>
        <p>{{ data.played }}</p>
      </v-flex>
      <v-flex style="padding-top: 65px;">
        <small>LIKED</small>
        <p>{{ data.likes!=null?data.likes.length:0 }}</p>
      </v-flex>
      <v-flex style="padding-top: 65px;">
        <small>PINNED</small>
        <p>{{ data.pinned }}</p>
      </v-flex>
      <v-flex style="padding-top: 65px;">
        <small>CREATED</small>
        <p>{{ new Date(data.date * 1000) | dateFormat('DD.MM.YY') }}</p>
      </v-flex>
    </v-layout>

    <v-layout row class="py-3">
      <v-flex xs9>
        <div class="display-1 mb-2">Promo settings</div>
        <v-divider />
        <v-layout row align-start class="pt-4">
          <v-layout>
            <v-switch v-model="data.is_promo" label="Is promo only" />
          </v-layout>
          <v-layout>
            <v-text-field v-if="data.is_promo" :label="'Search by code'" type="text" outline
              @input="filterPromo"></v-text-field>
            <v-select v-if="data.is_promo" label="Promos" v-model="data.id_promo" chips :items="promosFiltered"
              item-text="value" item-value="id_promo" solo multiple></v-select>
          </v-layout>

        </v-layout>

        <v-layout align-start column justify-center fill-height>
          <h2>Playlist PRO game</h2>
          <v-switch v-model="data.show" label="VISIBLE" />
          <v-switch v-model="data.suite_for_school" label="SUITE FOR SCHOOL" />
            <v-switch v-model="data.isBonus" label="Is BONUS" />
            <v-text-field style="height: 50px !important;max-height: 50px;" label="Bonus order index" type="number" outline v-model="data.bonus_index_order" />
          <v-switch v-model="data.is_recommended" label="Is recommended game" />
        </v-layout>
        <!-- <input v-show="false" ref="preview" type="file" accept="image/*" @change="updatePreview"> -->
        <input v-show="false" ref="file" type="file" accept="image/svg+xml" @change="updateImage">
        <input v-show="false" ref="audioHeb" type="file" accept="audio/*" @change="updateAudioHeb">
        <input v-show="false" ref="audioEng" type="file" accept="audio/*" @change="updateAudioEng">
        <input v-show="false" ref="audioRu" type="file" accept="audio/*" @change="updateAudioRu">
        <input v-show="false" ref="audioAr" type="file" accept="audio/*" @change="updateAudioAr">

        <input v-show="false" ref="previewHeb" type="file" accept="image/*" @change="updatePreviewHeb">
        <input v-show="false" ref="previewEng" type="file" accept="image/*" @change="updatePreviewEng">
        <input v-show="false" ref="previewRu" type="file" accept="image/*" @change="updatePreviewRu">
        <input v-show="false" ref="previewAr" type="file" accept="image/*" @change="updatePreviewAr">

        <input v-show="false" ref="videoHeb" type="file" accept="video/*" @change="updateVideoHeb">
        <input v-show="false" ref="videoEng" type="file" accept="video/*" @change="updateVideoEng">
        <input v-show="false" ref="videoRu" type="file" accept="video/*" @change="updateVideoRu">
        <input v-show="false" ref="videoAr" type="file" accept="video/*" @change="updateVideoAr">


      </v-flex>
      <v-flex xs3>
        <v-layout align-center justify-end style="position: fixed;
    top: 10px;
    right: 10px;">
          <v-btn color="error" @click="dialog.delete = true" flat>DELETE</v-btn>
          <v-btn color="success" @click="save">SAVE</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout style="display: block;padding-top: 80px;">
      <v-layout>
        <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.file.click()">
          Upload image
        </v-btn>
        <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteImage()">
          Delete image
        </v-btn>
      </v-layout>

      <v-layout style="margin-top: 10px;">
        <div style="width: 100%; text-align: left;">
          <h4 style="margin-left: 20px;margin-bottom: 5px;">Preview upload</h4>
        </div>
      </v-layout>
      <v-layout>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.previewHeb.click()">
            Upload preview heb
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deletePreviewHeb()">
            Delete preview heb
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.previewEng.click()">
            Upload preview eng
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deletePreviewEng()">
            Delete preview eng
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.previewRu.click()">
            Upload preview ru
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deletePreviewRu()">
            Delete preview ru
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.previewAr.click()">
            Upload preview ar
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deletePreviewAr()">
            Delete preview ar
          </v-btn>
        </div>
      </v-layout>
      <v-layout style="margin-top: 10px;">
        <div style="width: 100%; text-align: left;">
          <h4 style="margin-left: 20px;margin-bottom: 5px;">Audio upload</h4>
        </div>
      </v-layout>
      <v-layout>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.audioHeb.click()">
            Upload audio heb
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteAudioHeb()">
            Delete audio heb
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.audioEng.click()">
            Upload audio eng
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteAudioEng()">
            Delete audio eng
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.audioRu.click()">
            Upload audio ru
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteAudioRu()">
            Delete audio ru
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" small color="info" @click="$refs.audioAr.click()">
            Upload audio ar
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteAudioAr()">
            Delete audio ar
          </v-btn>
        </div>
      </v-layout>
      <v-layout style="margin-top: 10px;">
        <div style="width: 100%; text-align: left;">
          <h4 style="margin-left: 20px;margin-bottom: 5px;">Video upload</h4>
        </div>
      </v-layout>
      <v-layout>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" :loading="loading.video" small color="info"
            @click="$refs.videoHeb.click()">
            Upload video heb
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteVideoHeb()">
            Delete video heb
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" :loading="loading.video" small color="info"
            @click="$refs.videoEng.click()">
            Upload video eng
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteVideoEng()">
            Delete video eng
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" :loading="loading.video" small color="info"
            @click="$refs.videoRu.click()">
            Upload video ru
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteVideoRu()">
            Delete video ru
          </v-btn>
        </div>
        <div style="display: inline-block; width: 160px !important;">
          <v-btn style="margin: 5px;width: 150px;" :loading="loading.video" small color="info"
            @click="$refs.videoAr.click()">
            Upload video ar
          </v-btn>
          <v-btn style="margin: 5px;width: 150px;" small color="red" @click="deleteVideoAr()">
            Delete video ar
          </v-btn>
        </div>
      </v-layout>
    </v-layout>
    
    <v-text-field label="Video embed frame" v-model="data.video" outline></v-text-field>
    <span>Width: 250   Height: 170</span>
    
    <v-divider></v-divider>

    <v-form class="pt-4">
      <v-text-field label="Order index" type="number" outline v-model="data.order_index" />

      <v-text-field label="Game name" type="text" v-model="data.name" outline></v-text-field>

      <div class="display-1 mb-2">Strips
        <span v-if="langHeb"> He</span>
        <span v-if="langEng"> Eng</span>
        <span v-if="langAr"> Ar</span>
        <span v-if="langRu"> Ru</span>
      </div>
      <v-divider />
      <div class="pt-4" v-if="langHeb">
        <v-textarea label="Strip 1" @input="setTranslate1" v-model="data.question_1" box></v-textarea>
        <v-textarea label="Strip 2" @input="setTranslate2" v-model="data.question_2" box></v-textarea>
        <v-textarea label="Strip 3" @input="setTranslate3" v-model="data.question_3" box></v-textarea>
      </div>
      <div class="pt-4" v-else-if="langEng">
        <v-textarea label="Strip 1" @input="setTranslate1" v-model="data.translation[1].data.question_1" box></v-textarea>
        <v-textarea label="Strip 2" @input="setTranslate2" v-model="data.translation[1].data.question_2" box></v-textarea>
        <v-textarea label="Strip 3" @input="setTranslate3" v-model="data.translation[1].data.question_3" box></v-textarea>
      </div>
      <div class="pt-4" v-else-if="langAr">
        <v-textarea label="Strip 1" @input="setTranslate1" v-model="data.translation[3].data.question_1" box></v-textarea>
        <v-textarea label="Strip 2" @input="setTranslate2" v-model="data.translation[3].data.question_2" box></v-textarea>
        <v-textarea label="Strip 3" @input="setTranslate3" v-model="data.translation[3].data.question_3" box></v-textarea>
      </div>
      <div class="pt-4" v-else>
        <v-textarea label="Strip 1" @input="setTranslate1" v-model="data.translation[2].data.question_1" box></v-textarea>
        <v-textarea label="Strip 2" @input="setTranslate2" v-model="data.translation[2].data.question_2" box></v-textarea>
        <v-textarea label="Strip 3" @input="setTranslate3" v-model="data.translation[2].data.question_3" box></v-textarea>
      </div>
      <div class="languages">
        <div v-if="lang.length > 0" class="display-1 mb-2">Translate</div>
        <template v-for="trans in data.translation">
          <v-btn text @click="setLang(trans)" color="info">{{ getLang(trans) }}</v-btn>
        </template>
      </div>
      <v-divider />
      <div class="display-1 mb-2">Ingame subgoals</div>
      <v-layout>
        <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
      </v-layout>
      <v-layout row align-start class="pt-4">
        <v-select label="SubGoals" @input="onSubGoalsChange" v-model="data.subgoals" chips :items="subgoalsFiltered"
          item-text="name" item-value="id" solo multiple></v-select>
      </v-layout>
      <div class="display-1 mb-2">Ingame sorts</div>
      <v-layout>
        <v-text-field @input="seatchMethodSorts" v-model="searchSorts" solo label="Search"></v-text-field>
      </v-layout>
      <v-layout row align-start class="pt-4">
        <v-select label="Sorts" @input="onSortsChange" v-model="data.sorts" chips :items="sortsFiltered"
          item-text="value" item-value="id" solo multiple></v-select>
      </v-layout>

      <v-divider />
      <v-layout> 
                <span style="font-size: 20px; font-weight: bold; color:brown;">Since the value “age” exceeds the range of integers, age will now be indicated using an ID.<br>
                IDs from 1 to 13 correspond to age, while ID 14 represents “הגיל השלישי”.</span>
</v-layout>
      <v-divider />
      <div class="display-1 mb-2">Min Child Age ID</div>
      <v-layout>
        <input
          style="    height: 48px;
    padding: 10px;
    border-radius: 5px;
    margin-left: 10px;
    width: 100px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;"
          v-model="data.minChildLevel" solo label="Min Child Age" type="number" :min="1" :max="14" step="1" />
      </v-layout>
      <v-divider />
      <div class="display-1 mb-2">Max Child Age ID</div>
      <v-layout>
        <input
          style="    height: 48px;
    padding: 10px;
    border-radius: 5px;
    margin-left: 10px;
    width: 100px;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;"
          v-model="data.maxChildLevel" solo label="Max Child Age" type="number" :min="1" :max="14" step="1" />
      </v-layout>
      <v-divider />
    
      <div class="display-1 mb-2">
        Credit
        <v-icon @click="deleteAuthor">delete</v-icon>
      </div>
      <v-divider />
      <v-layout row align-start class="pt-4">
        <v-text-field @input="searchUser" label="User name" v-model="user" type="text" solo></v-text-field>
        <v-select label="User" v-model="data.id_author" :items="users" item-text="name" item-value="id_user"
          solo></v-select>
      </v-layout>
      <v-layout row align-start class="pt-4">
        <v-text-field label="Social link" v-model="data.social" type="text" solo></v-text-field>
      </v-layout>


      <div class="display-1 mb-2">Teacher guide</div>
      <v-divider />
      <v-layout row align-start class="pt-4">
        <v-text-field label="Teacher guide" v-model="data.translation[0].data.teachers_guide" type="text"
          outline></v-text-field>
      </v-layout>
    </v-form>

    <v-snackbar v-model="alert.update" right top :timeout="2000">
      Updated.
      <v-btn color="pink" flat @click="alert.update = false">
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="alert.delete" right top :timeout="2000">
      Deleted.
      <v-btn color="pink" flat @click="alert.delete = false">
        Close
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog.delete" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Delete ensurance
        </v-card-title>

        <v-card-text>
          Do you realy want to delete it?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" flat @click="dialog.delete = false">
            Cancel
          </v-btn>
          <v-btn color="error" flat @click="remove">
            Yes, delete it
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="transLang" v-model="dialogTr" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Updating translate {{ getLang(transLang) }}
        </v-card-title>

        <v-card-text>
          <v-text-field label="Name" v-model="transLang.data.name" category="text"></v-text-field>
          <v-text-field label="Question 1" v-model="transLang.data.question_1" category="text"></v-text-field>
          <v-text-field label="Question 2" v-model="transLang.data.question_2" category="text"></v-text-field>
          <v-text-field label="Question 3" v-model="transLang.data.question_3" category="text"></v-text-field>
          <v-text-field label="Question 4" v-model="transLang.data.question_4" category="text"></v-text-field>
          <v-text-field label="Question 5" v-model="transLang.data.question_5" category="text"></v-text-field>
          <v-text-field label="Teacher Guide" v-model="transLang.data.teachers_guide" category="text"></v-text-field>
          <v-layout justify-end>
          </v-layout>

          <v-btn @click="save" color="success">
            update
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuetifyAudio from 'vuetify-audio'
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';

export default {
  components: {
    VuetifyAudio,
  },
  data() {
    return {
      data: [],
      test: null,
      lang: [],
      subgoals: [],
      subgoalsFiltered: [],
      sorts: [],
      sortsFiltered: [],
      school: '',
      alert: {
        update: false,
        delete: false,
      },
      dialog: {
        delete: false,
      },
      loading: {
        video: false,
      },
      transLang: '',
      user: '',
      users: [],
      schools: [],
      langHeb: true,
      langRu: false,
      langEng: false,
      langAr: false,
      locations: [],
      locationsFiltered: [],
      search: '',
      searchSorts: '',
      searchLocations: '',
      promos: [],
      promosFiltered: [],
      comments: null
    };
  },
  methods: {
    deleteItem(id)
    {
      axios.post('/playlist/deleteComment',{id:id}).then((res)=>{
        let idIndex = this.comments.findIndex((x) => x.id ==id);

        if (idIndex !== -1) {
          // Remove from this.selectedIdsArray
          this.comments.splice(idIndex, 1);
        }
        this.$notify({
                    title: "success",
                    text: "Updated!",
                    type: "success",
                    duration: 5000,
                });
            }).catch(err => {
                this.$notify({
                    title: "error",
                    text: "Error on update",
                    type: "error",
                    duration: 5000,
                });
            });
    },
    getPromoCodes() {
      axios.get('/admin/promo').then(res => {
        this.promos = res.data.sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
        this.promosFiltered = res.data.sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
      });
    },
    filterPromo(e) {
      this.promosFiltered = this.promos.filter(x => x.value.toLowerCase().includes(e.toLowerCase()));
    },
    normilize(val) {
      if (val <= 0) {
        this.data.childLevel = 1;
      }
      else if (val > 8) {
        this.data.childLevel = 8;
      }
      else {

      }
    },
    seatchMethodLocations(val) {
      if (this.searchLocations == '') {
        this.locationsFiltered = this.locations.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;
      }
      else {
        this.locationsFiltered = this.locations.filter(element => {
          return (element.name).includes(this.searchLocations)
        });
      }
    },
    seatchMethodSorts(val) {
      if (this.searchSorts == '') {
        this.sortsFiltered = this.sorts.sort((a, b) => {
          const nameA = a.value.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.value.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.sortsFiltered = this.sorts.filter(element => {
          return (element.value).includes(this.searchSorts)
        });
      }
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.subgoalsFiltered = this.subgoals.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.subgoalsFiltered = this.subgoals.filter(element => {
          return (element.name).includes(this.search)
        });
      }
    },
    setTranslate1(val) {
      this.data.translation[0].data.question_1 = val;
    },
    setTranslate2(val) {
      this.data.translation[0].data.question_2 = val;
    },
    setTranslate3(val) {
      this.data.translation[0].data.question_3 = val;
    },
    setLang(lang) {
      let val = lang.langKey;
      switch (val) {
        case 'heb':
          this.langHeb = true;
          this.langEng = false;
          this.langAr = false;
          this.langRu = false;
          break;
        case 'en':
          this.langHeb = false;
          this.langEng = true;
          this.langAr = false;
          this.langRu = false;
          break;
        case 'ru':
          this.langHeb = false;
          this.langEng = false;
          this.langAr = false;
          this.langRu = true;
          break;
        case 'ar':
          this.langHeb = false;
          this.langEng = false;
          this.langAr = true;
          this.langRu = false;
          break;
        default:
          this.langHeb = true;
          this.langEng = false;
          this.langAr = false;
          this.langRu = false;
          break;
      }
    },
    getLang(trans) {
      let item = this.lang.find(item => { return item.lang_code === trans.langKey });
      return item ? item.lang_title : (trans.langKey === 'heb' ? 'Hebrew' : trans.langKey)
    },
    onSubGoalsChange(value) {

      this.data.subgoals = value.map(n => {
        return n
      });
    },
    onSortsChange(value) {

      this.data.sorts = value.map(n => {
        return n
      });
      },

    onLocationsChange(value) {
      this.data.locations = value.map(n => {
        return n
      });
    },
    updateImage() {
      let file = this.$refs.file.files[0];
      let reader = new FileReader();

      reader.onloadend = () => {
        let base64data = reader.result;
        base64data = base64data.replace('data:image/svg+xml;base64,', '');
        axios.post('/playlist/' + this.$route.params.id_playlist + '/image', { image: base64data }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          this.data.img = res.data.url;
        });
      };

      reader.readAsDataURL(file);
    },
    deleteImage() {
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/image').then(res => {
        this.data.img = null;
      });
    },
    //Preview
    updatePreviewHeb() {
      var data = new FormData();
      data.append('file', this.$refs.previewHeb.files[0]);
      data.append('lang', 'heb');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/preview', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.preview = res.data.url;
      });
    },
    deletePreviewHeb() {
      let lang = 'heb';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/preview/' + lang).then(res => {
        this.data.preview = null;
      });
    },
    updatePreviewRu() {
      var data = new FormData();
      data.append('file', this.$refs.previewRu.files[0]);
      data.append('lang', 'ru');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/preview', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.preview = res.data.url;
      });
    },
    deletePreviewRu() {
      let lang = 'ru';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/preview/' + lang).then(res => {
        this.data.preview = null;
      });
    },
    updatePreviewEng() {
      var data = new FormData();
      data.append('file', this.$refs.previewEng.files[0]);
      data.append('lang', 'eng');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/preview', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.preview = res.data.url;
      });
    },
    deletePreviewEng() {
      let lang = 'eng';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/preview/' + lang).then(res => {
        this.data.preview = null;
      });
    },
    updatePreviewAr() {
      var data = new FormData();
      data.append('file', this.$refs.previewAr.files[0]);
      data.append('lang', 'ar');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/preview', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.preview = res.data.url;
      });
    },
    deletePreviewAr() {
      let lang = 'ar';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/preview/' + lang).then(res => {
        this.data.preview = null;
      });
    },
    //Video
    updateVideoHeb() {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.videoHeb.files[0]);
      data.append('lang', 'heb');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/video', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data._video = res.data.url;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    updateVideoEng() {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.videoEng.files[0]);
      data.append('lang', 'eng');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/video', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data._video = res.data.url;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    updateVideoRu() {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.videoRu.files[0]);
      data.append('lang', 'ru');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/video', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data._video = res.data.url;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    updateVideoAr() {
      var data = new FormData();
      this.loading.video = true;
      data.append('file', this.$refs.videoAr.files[0]);
      data.append('lang', 'ar');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/video', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data._video = res.data.url;
      }).finally(() => {
        this.loading.video = false;
      });
    },
    //
    deleteVideoHeb() {
      let lang = 'heb';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/video/' + lang).then(res => {
        this.data._video = null;
      });
    },
    deleteVideoEng() {
      let lang = 'eng';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/video/' + lang).then(res => {
        this.data._video = null;
      });
    },
    deleteVideoRu() {
      let lang = 'ru';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/video/' + lang).then(res => {
        this.data._video = null;
      });
    },
    deleteVideoAr() {
      let lang = 'ar';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/video/' + lang).then(res => {
        this.data._video = null;
      });
    },
    //Audio
    updateAudioHeb() {
      var data = new FormData();
      data.append('file', this.$refs.audioHeb.files[0]);
      data.append('lang', 'heb');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/audio', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.audio = res.data.url;
      });
    },
    updateAudioEng() {
      var data = new FormData();
      data.append('file', this.$refs.audioEng.files[0]);
      data.append('lang', 'eng');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/audio', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.audio = res.data.url;
      });
    },
    updateAudioRu() {
      var data = new FormData();
      data.append('file', this.$refs.audioRu.files[0]);
      data.append('lang', 'ru');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/audio', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.audio = res.data.url;
      });
    },
    updateAudioAr() {
      var data = new FormData();
      data.append('file', this.$refs.audioAr.files[0]);
      data.append('lang', 'ar');
      axios.post('/playlist/' + this.$route.params.id_playlist + '/audio', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.data.audio = res.data.url;
      });
    },
    //
    deleteAudioHeb() {
      let lang = 'heb';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/audio/' + lang).then(res => {
        this.data.audio = null;
      });
    },
    deleteAudioEng() {
      let lang = 'eng';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/audio/' + lang).then(res => {
        this.data.audio = null;
      });
    },
    deleteAudioRu() {
      let lang = 'ru';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/audio/' + lang).then(res => {
        this.data.audio = null;
      });
    },
    deleteAudioAr() {
      let lang = 'ar';
      axios.delete('/playlist/' + this.$route.params.id_playlist + '/audio/' + lang).then(res => {
        this.data.audio = null;
      });
    },
    deleteAuthor() {
      this.users = [];
      this.user = '';
      this.data.id_author = null;

      this.schools = [];
      this.school = '';
      this.data.id_school = null;

      this.data.city = null;
    },
    encryptObject(data) {
      const key = CryptoJS.enc.Utf8.parse(process.env['VUE_APP_SECURE_KEY']);
      const iv = CryptoJS.lib.WordArray.random(16);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

      const objectToEncryptString = JSON.stringify(data);

      const encrypted = CryptoJS.AES.encrypt(objectToEncryptString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        keySize: 256 / 8,
      });

      const encryptedObject = {
        iv: ivBase64,
        value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      };
      return encryptedObject;
    },
    decryptData(res) {
      var key = process.env["VUE_APP_SECURE_KEY"];
      var encrypted = res.payload;
      var encrypted_json = JSON.parse(Base64.decode(encrypted));
      var decrypted = CryptoJS.AES.decrypt(encrypted_json.value, CryptoJS.enc.Base64.parse(Base64.encode(key)), {
        iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
        mode: CryptoJS.mode.CBC
      });
      let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

      return data;
    },
    searchUser() {
      if (!this.user.length) return;
      axios.post('/user/search', this.encryptObject({
        name: this.user
      })).then(res => {
        let data = this.decryptData(res.data)
        this.users = data.map(n => {
          n.name = n.name + ' ' + n.surname;
          return n;
        });
        this.users.unshift({
          name: 'Empty',
          id_user: null,
        });
      });
    },
    getComments(){
      axios.post('/playlist/getComments',{id_playlist:this.data.id_playlist}).then((res)=>{
        this.comments = res.data;
      });
    },
    sync() {
      axios.get('/playlist/' + this.$route.params.id_playlist + '/full').then(res => {
        this.data = res.data;

        if (res.data.author_info) {
          this.users.push({
            name: 'Empty',
            id_user: null,
          });
          this.users.push(res.data.author_info);
          this.user = res.data.author_info.name;

        }
        if (res.data.school_info) {
          this.schools.push({
            name: 'Empty',
            id_school: null,
          });
          this.schools.push(res.data.school_info);
          this.school = res.data.school_info.name;
        }

        
      });
      this.lang = JSON.parse(localStorage.getItem('translate'));

    },
    async syncSubGoals() {
      await axios.get("/admin/treatment/getSubGoals").then((res) => {
        this.subgoals = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
        this.subgoalsFiltered = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      });
    },
    async syncLocations() {
      await axios.get('/playlist/settings').then(res => {
        this.locations = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
        this.locationsFiltered = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      });
    },
    async syncSorts() {
            await axios
                .get("/playlist-sorts/index").then((res)=>{
                    this.sorts = res.data.sort((a, b) => {
  const nameA = a.id; // Convert names to uppercase for case-insensitive sorting
  const nameB = b.id;

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0; // Names are equal
});

                    this.sortsFiltered = res.data.sort((a, b) => {
  const nameA = a.id; // Convert names to uppercase for case-insensitive sorting
  const nameB = b.id;

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0; // Names are equal
});
;;
                })
        },
    save() {
      if(parseInt(this.data.minChildLevel)>parseInt(this.data.maxChildLevel)) {
        alert('Min age cannot be greater than max age.')
      }
      else{
        this.data.translation[0].data.name = this.data.name;

        console.log(typeof this.data)
        axios.put('/playlist/' + this.$route.params.id_playlist, this.data).then(res => {
          this.alert.update = true;
        });
        this.dialogTr = false;
      }
    },
    remove() {
      axios.delete('/playlist/' + this.$route.params.id_playlist).then(res => {
        this.dialog.delete = false;
        this.alert.delete = true;
        this.$router.push('/playlist-pro');
      })
    },
    searchSchool() {
      if (!this.school.length) return;
      axios.post('/school/search', {
        name: this.school,
      }).then(res => {
        this.schools = res.data;
        this.schools.unshift({
          name: 'Empty',
          id_school: null,
        });
      });
    },
  },
  async created() {
    await this.syncSubGoals();
    // await this.syncLocations();
    await this.syncSorts();
    await this.getPromoCodes();
    this.sync();
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 10px;
}

.main {
  padding-top: 20px;
}

.title {
  text-transform: uppercase;
}

.col {
  padding: 10px 20px;
}

.desc {
  text-transform: uppercase;
  font-weight: 500;
  color: silver;
}

.languages {
  margin-bottom: 20px;
}
</style>
